<div class="p500-ui-modal__footer">
  <button type="button" p500-ui-button stroked="true" class="mr-10" (click)="cancel(); $event.preventDefault()" i18n="@@common.cancel">
    Cancel
  </button>
  <button type="button" p500-ui-button color="warn" (click)="close(); $event.preventDefault()" i18n="@@common.close">Close</button>
</div>
